import React, { memo, useRef, useEffect } from "react";
import { useFrame } from "react-three-fiber";
import gsap from "gsap";

import BubbleMaterial from "shaders/bubble";

const Bubble = ({ map, refractMap }) => {
  const mesh = useRef();
  const material = useRef(new BubbleMaterial({ map, refractMap }));

  useEffect(() => {
    if (material.current.uniforms.map.value.id !== map.id) {
      const anim = gsap.to(mesh.current.rotation, {
        id: "slider",
        duration: 1,
        x: Math.PI * 2 * 4,
        ease: "expo.inOut",
        onUpdate: () => {
          if (anim.progress() > 0.5) {
            mesh.current.material.uniforms.map.value = map;
          }
        },
        onComplete: () => {
          mesh.current.rotation.x = 0;
        },
      });
    }
  }, [map]);

  useFrame(({ mouse }) => {
    material.current.uniforms.mouse.value = mouse;
    material.current.uniforms.time.value += 1;
  }, 1);

  return (
    <mesh ref={mesh} material={material.current} position={[0, 0, -1]}>
      <octahedronBufferGeometry attach="geometry" args={[3.5, 5]} />
    </mesh>
  );
};

export default memo(Bubble);
